import React, { useState } from 'react';

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  isActive?: boolean;
  isSubmenu?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({ title, children, isActive, isSubmenu }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`${isSubmenu ? 'pl-4' : ''}`}>
      <button
        className={`flex justify-between items-center w-full px-4 py-2 text-lg font-medium text-left ${
          isActive
            ? 'text-white bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text [-webkit-text-fill-color:transparent]'
            : 'text-gray-900'
        } hover:text-white hover:bg-gradient-to-r hover:from-[#AE7D2F] hover:via-[#ECD05B] hover:to-[#AE7D2F] hover:bg-clip-text hover:[-webkit-text-fill-color:transparent]`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{title}</span>
        <span>{isOpen ? '−' : '+'}</span>
      </button>
      <div
        className={`transition-all duration-300 ease-in-out overflow-hidden ${
          isOpen ? 'max-h-screen' : 'max-h-0'
        }`}
      >
        <div className="py-2">{children}</div>
      </div>
    </div>
  );
};

export default Accordion;